module.exports = go;


//////////////////
// WEBPACK FOOTER
// external "go"
// module id = 1038
// module chunks = 385